export enum DeviceOS {
  Android = 1,
  iOS = 2,
  Desktop = 3,
}
export enum DeviceType {
  None,
  Mobile = 1,
  Desktop = 2,
  Tablet = 3,
}
export enum MailType {
  None = 1,
  PasswordRecoveryLinkEmail = 2,
  PasswordChangedSuccessfullEmail = 3,
  ExpiredPasswordChangedSuccessfullEmail = 4,
  ResetCodeEmail = 5,
}

export enum ActionType {
  None = 0, //
  ForgotPassword = 1,
  EditPatient = 2,
  CreateNewPatient = 3,
  EndSession = 4,
  SuccessCreatePatient = 5,
  SuccessUpdatePatient = 6,
  SuccessPasswordReset = 10,
  FailureAPIResponse = 8,
  SuccessUpdateUser = 9,
  NewUser = 11,
  EditClinician = 12,
  PatientAlreadyExist = 13,
  EmailAlreadyExist = 14,
  ExitPatientSetup = 15,
  WrongCreds = 16,
  UserDoesNotExist = 17,
  UserDeactivated = 18,
  ExitUserSetup = 19,
  ExitForgotPassword = 20,
  Logout = 21,
  EditUserProfile = 22,
  ExitUserSetupFromCode = 23,
  ExitUserSetupFromSignup = 24,
  ExitUserSetupFromSignupPassword = 25,
  LoadSaving = 26,
  LoadSending = 27,
  SuccessExercisePlanSent = 28,
  SuccessExercisePlanSaved = 29,
  SuccessUpdateUserProfile = 30,
  SuccessPrintExercisePlan = 31,
  ErrorPrintExercisePlan = 32,
  LoadPrinting = 33,
  ExpiredPassword = 34,
  ErrorEditPatient = 35,
  ExitExpiredPassword = 36,
  PatientDoesNotExist = 37,
}

export enum BusinessType {
  Cloud = 1,
  DirectConnect = 2,
}

export enum ApplicationLookup {
  Sync = 1,
  DirectConnect = 2,
  Cloud = 3,
  iOS = 4,
  Android = 5,
  Desktop = 6,
}

export enum Lookups {
  Setting = 1,
  Referral = 2,
  Physician = 3,
  Tags = 4,
  Diagnosis = 5,
  Department = 6,
  Role = 7,
  Medications = 8,
  Mobilities = 9,
  FollowUpType = 10,
  Other = 0,
}

export enum PatientSetting {
  AssistedLiving = 1,
  IndependentLiving = 2,
  LongTermCare = 3,
  ShortTermCare = 4,
  Other = 5,
  None = 6,
}

export enum VisitTypes {
  Screen = 1,
  InitialEvaluation = 2,
  Reassessment = 3,
  Discharge = 4,
}

export enum TestType {
  none = 0,
  ctsib = 1,
  reach = 2,
  training = 3,
  ybalance_upper = 4,
  ybalance_lower = 5,
  vertical_jump = 6,
  hop_double_leg = 7,
  deep_squat = 8,
  hurdle_step = 9,
  in_line_lunge = 10,
  shoulder_mobility = 11,
  straight_leg_raise = 12,
  trunk_punshup = 13,
  rotary_stability = 14,
  height_measure = 15,
  ctsib_single_leg_left = 16,
  ctsib_single_leg_right = 17,
  sensory_organization = 18,
  sensory_organization_training_store = 19,
  sensory_organization_training_street = 20,
  hec_training = 21,
  gait = 22,
  tinetti_balance = 23,
  tinetti_gait = 24,
  bess = 25,
  cognitive = 26,
  berg_scripted = 27,
  deep_squat_smart = 28,
  box_jump = 29,
  excursion_lower = 30,
  tug = 31,
  als = 32,
  amp_scripted = 33,
  amp_scripted_no = 34,
  five_x_sit_stand = 35,
  marker_based_gait = 36,
  sitting_reach = 37,
  game_lean = 38,
  game_reach = 39,
  game_speed = 40,
  veggie_samurai = 41,
  simon_says_game = 42,
  aerobics_game = 43,
  sequence_game = 44,
  memory_game = 45,
  steadi = 46,
  timed_sit_stand = 47,
  four_stage_balance = 48,
  sensory_organization_training = 49,
  upper_body_arom = 55,
  // functional_reach = 56,
  red_light_green_light = 51,
  game_AF = 50,
  game_BalloonPopper = 58,
  // mCTSIB = 1,
}

export enum ConversionRequired {
  None = 0,
  MeterToInches,
  MeterToCentiMeter,
  NewtonToPounds,
  MeterToFeet,
  MilliSecToSeconds,
  CentimeterToMeter,
  BooleanToNumeric,
  CentimeterToInches,
}

export enum ResponseCode {
  GeneralFailed = 0,
  Success,
  AccessDenied,
  UserDisabled,
  InvalidLoginPassword,
  InvalidUserName,
  InvalidEmail,
  InvalidToken,
  UserAlreadyLoggedIn,
  ValidationFailed,
  InvalidCourseID,
  PasswordExpired,
  SystemError,
  InvalidIds,
  UserDoesNotExist,
  UnAuthorizedUser,
  MultipleUsers,
  PasswordAttemptsExceeded,
}

// these enums are used for ExerciseReport CSS
export enum TextAlign {
  Left = "left",
  Right = "right",
  Center = "center",
  Justify = "justify",
}
export enum Position {
  Static = "static",
  Relative = "relative",
  Fixed = "fixed",
  Absolute = "absolute",
  Sticky = "sticky",
}
export enum FontStyle {
  Normal = "normal",
  Italic = "italic",
  Oblique = "oblique",
}
export enum TextTransform {
  UpperCase = "uppercase",
  LowerCase = "lowercase",
}

export enum AROM_ASSESSMENT {
  Shoulder_AAA = "shoulderA&A",
  Left_Shoulder_FAE = "left_shoulderF&E",
  Right_Shoulder_FAE = "right_shoulderF&E",
  Left_Elbow_FAE = "left_elbowF&E",
  Right_Elbow_FAE = "right_elbowF&E",
  Left_Shoulder_IAE_Rotation = "left_shoulderI&E_Rotation",
  Right_Shoulder_IAE_Rotation = "right_shoulderI&E_Rotation",
}

export enum mCTSIB_ASSESSMENT {
  Open_Eyes = "openEyes",
  Closed_Eyes = "closedEyes",
  Foam_Closed_Eyes = "foamClosedEyes",
  Foam_Open_Eyes = "foamOpenEyes",
}

export enum FUNCTIONAL_REACH_ASSESSMENT {
  Right_Reach = "rightReach",
  Left_Reach = "leftReach",
  Forward_Reach = "forwardReach",
}
